// ================================
// src/main.tsx — FINAL (2025-10)
// - React 18 createRoot
// - i18n & global.css 로드
// - 모바일 100vh 보정(--vh CSS 변수)
// - StrictMode 안전 적용
// ================================
import React from "react";
import { createRoot } from "react-dom/client";

import "./i18n";
import "./global.css";
import App from "./App";

// 모바일 주소창에 따른 100vh 보정 (CSS에서 height: calc(var(--vh) * 100) 등으로 활용 가능)
function setViewportVH() {
  try {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  } catch {}
}
setViewportVH();
window.addEventListener("resize", setViewportVH);
window.addEventListener("orientationchange", setViewportVH);

// 루트 렌더
const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error('Root element "#root" not found in index.html');
}

createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
